import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import * as Roles from '../../common/Roles';

const states: Ng1StateDeclaration[] = [{
    name: 'linked',
    url: '/linked/:linkedGuid',
    component: 'wtLinkedState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.operator, Roles.reader])
    },
    data: {
        ignoreHistory: true
    }
}];

export default states;